import { render, staticRenderFns } from "./ModalDetalhesPostoAvancado.vue?vue&type=template&id=489a9cfa&scoped=true"
import script from "./ModalDetalhesPostoAvancado.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesPostoAvancado.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhesPostoAvancado.vue?vue&type=style&index=0&id=489a9cfa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a9cfa",
  null
  
)

export default component.exports